<template>
	<div>
		<div v-if="!isLoading" class="__report-lesson px-12 md-down:px-4 pb-30">
			<div
				class="
					__report-lesson__header
					pt-10
					pb-10
					flex flex-nowrap
					justify-between
					items-center
				"
			>
				<div
					class="
						__record__title
						text-neutral-500
						font-semibold
						whitespace-nowrap
						flex flex-nowrap
						items-center
						text-4xl
					"
				>
					<svg
						width="28"
						height="28"
						viewBox="0 0 28 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<g clip-path="url(#clip0_19866_8555)">
							<path
								d="M25.2762 3.5H2.7246C2.36678 3.49993 2.01245 3.57382 1.68184 3.71744C1.35124 3.86106 1.05083 4.0716 0.79779 4.33705C0.544746 4.60249 0.344018 4.91763 0.20707 5.26447C0.0701211 5.61131 -0.000365805 5.98306 -0.000365799 6.35849V21.6415C-0.000562697 22.0171 0.069779 22.389 0.20664 22.736C0.3435 23.083 0.544197 23.3984 0.797259 23.664C1.05032 23.9296 1.35079 24.1403 1.68149 24.284C2.0122 24.4277 2.36665 24.5016 2.7246 24.5016H25.2762C25.9987 24.5016 26.6917 24.2004 27.2027 23.6643C27.7136 23.1283 28.0006 22.4012 28.0006 21.6431V6.35849C28.0006 5.60037 27.7136 4.8733 27.2027 4.33723C26.6917 3.80116 25.9987 3.5 25.2762 3.5ZM12.6379 5.6782H15.3624C15.3955 5.67951 15.4275 5.69085 15.4547 5.71084C15.4818 5.73083 15.5028 5.75863 15.5152 5.79088V7.65828H12.538V5.87631C12.5267 5.83614 12.5308 5.79292 12.5495 5.7559C12.5682 5.71888 12.5999 5.69099 12.6379 5.6782ZM5.48254 22.2925C5.43259 22.2925 5.35516 22.3202 5.30421 22.3202H2.75657C2.60372 22.3202 2.52779 22.2925 2.52779 22.0975V20.3422H5.48154L5.48254 22.2925ZM5.45707 7.68449H2.70662C2.67115 7.68808 2.63564 7.67802 2.60671 7.65618V5.79088C2.63219 5.7348 2.68314 5.67925 2.73409 5.67925H5.40811C5.48454 5.65147 5.53549 5.70702 5.56097 5.79088V5.84644C5.58645 6.40409 5.58645 6.96174 5.58645 7.51887C5.55897 7.6022 5.53349 7.65776 5.45707 7.68606V7.68449ZM10.4479 22.2925C10.3715 22.2925 10.3205 22.3202 10.2696 22.3202H7.72196C7.62206 22.348 7.54413 22.2925 7.49318 22.1808V20.3145H10.4469L10.4479 22.2925ZM10.4479 7.71226H7.75044C7.67401 7.71226 7.62355 7.65618 7.5726 7.60063V5.73428H10.3225C10.4225 5.7065 10.5009 5.76205 10.5518 5.87369V7.49057C10.5626 7.53466 10.558 7.58133 10.539 7.62224C10.52 7.66314 10.4877 7.69561 10.4479 7.71384V7.71226ZM15.4133 22.2925C15.3369 22.2925 15.2859 22.3202 15.2095 22.3202H12.6619C12.509 22.3202 12.4581 22.2925 12.4581 22.0975V20.5094C12.4556 20.4434 12.4642 20.3774 12.4835 20.3145H15.4118L15.4133 22.2925ZM15.9548 14.7956L12.7378 16.8795C12.0944 17.3197 11.5629 16.9969 11.5629 16.2044V11.8019C11.5629 10.9801 12.0944 10.6866 12.7378 11.1268L15.9548 13.2107C16.5982 13.6525 16.5982 14.3553 15.9548 14.7956ZM20.3807 22.2107C20.3552 22.2662 20.3043 22.3218 20.2533 22.3218H17.5558C17.5059 22.3218 17.4559 22.2662 17.4284 22.2107V20.3428H20.3807V22.2107ZM20.5081 5.87369C20.4581 6.43134 20.4826 6.96122 20.4826 7.49057C20.4826 7.6022 20.4826 7.68606 20.3552 7.68606H17.5523V5.67872H20.3278C20.3465 5.67341 20.3661 5.67211 20.3853 5.67492C20.4045 5.67772 20.423 5.68456 20.4396 5.69503C20.4563 5.7055 20.4708 5.71938 20.4822 5.73585C20.4936 5.75232 20.5017 5.77104 20.5061 5.79088L20.5081 5.87369ZM25.3206 22.294H22.3903V20.3428H25.3186L25.3206 22.294ZM25.474 5.95755C25.424 6.45912 25.448 6.98899 25.448 7.51834C25.448 7.62998 25.423 7.71384 25.2951 7.71384H22.5976C22.5623 7.7173 22.5268 7.70746 22.4977 7.68606V5.7065H25.2477C25.3476 5.67872 25.426 5.73428 25.477 5.84591L25.474 5.95755Z"
								fill="#65758B"
							/>
						</g>
						<defs>
							<clipPath id="clip0_19866_8555">
								<rect
									width="28"
									height="21"
									fill="white"
									transform="translate(0 3.5)"
								/>
							</clipPath>
						</defs>
					</svg>
					<span class="ml-4 mt-2">Kho video</span>
				</div>
				<div class="mt-10">
					<button
						@click.stop="$router.push('/media-history')"
						type="button"
						class="
							button-p
							text-center
							bg-none
							shadow-none
							flex
							items-center
							justify-center
							btn--ghost
							w-fit
							px-4
						"
					>
						<span>Xem lịch sử</span>
					</button>
				</div>
			</div>
			<div class="relative mb-10">
				<div
					class="absolute inset-0 flex items-center"
					aria-hidden="true"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex justify-center">
					<div
						class="
							bg-body
							px-2
							text-neutral-600
							font-semibold
							whitespace-nowrap
							flex flex-nowrap
							items-center
							text-2xl
							justify-center
							gap-6
						"
					>
						<div
							class="cursor-pointer"
							@click="prevDay"
							v-if="date.month > 10 || date.year > 2022"
						>
							<svg
								width="8"
								height="12"
								viewBox="0 0 8 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M6.5 1L1.5 6L6.5 11"
									stroke="#48566A"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</div>
						<div v-if="date">Tháng {{ dateTitle }}</div>
						<div
							class="cursor-pointer"
							@click="nextDay"
							v-if="
								date.month < new Date().getMonth() ||
								date.year < new Date().getFullYear()
							"
						>
							<svg
								width="8"
								height="12"
								viewBox="0 0 8 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M1.5 11L6.5 6L1.5 1"
									stroke="#48566A"
									stroke-width="2"
									stroke-linecap="round"
									stroke-linejoin="round"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="bg-white p-6 rounded-lg shadow-sm text-gray-500">
				<div class="grid grid-cols-1 lg:grid-cols-3">
					<div
						class="
							p-4
							border
							lg:rounded-l-lg
							md:rounded-tl-lg
							border-neutral-200
							w-full
							md-down:rounded-t md-down:rounded-b-none
						"
					>
						<div>Dung lượng video khả dụng</div>
						<div class="text-4xl font-bold text-neutral-600 mt-2">
							{{ media.allocated_size }}
						</div>
					</div>
					<div
						class="
							p-4
							md:border-t md:border-b
							border-neutral-200
							w-full
						"
					>
						<div>Số dung lượng video đã sử dụng</div>
						<div class="text-4xl font-bold text-neutral-600 mt-2">
							{{ media.used_size }}
						</div>
					</div>
					<div
						class="
							p-4
							border
							lg:rounded-r-lg
							md:rounded-br-lg
							border-neutral-200
							w-full
							md-down:rounded-b md-down:rounded-t-none
						"
					>
						<div>Số dung lượng video chưa sử dụng</div>
						<div class="text-4xl font-bold text-neutral-600 mt-2">
							{{ media.unused_size }}
						</div>
					</div>
				</div>
				<div class="grid grid-cols-2 mt-6 gap-4">
					<div>
						<div class="font-semibold text-neutral-400">
							Số học sinh đăng ký
						</div>
						<div class="text-neutral-900 mt-2">
							{{ media.total_student }} học sinh
						</div>
					</div>
					<div>
						<div class="font-semibold text-neutral-400">
							Số dung lượng video/học sinh
						</div>
						<div class="text-neutral-900 mt-2">
							{{ media.allocated_per_student_in_mb }} MB / tháng
						</div>
					</div>
					<div>
						<div class="font-semibold text-neutral-400">
							Dung lượng video khả dụng
						</div>
						<div class="text-neutral-900 mt-2">
							{{ media.allocated_size }} / tháng
						</div>
					</div>
				</div>
			</div>
			<div class="shadow-sm sm:rounded-2xl mt-12" v-if="students.length">
				<div class="__record__table overflow-x-auto scroll-bar">
					<div
						class="
							overflow-hidden
							sm:rounded-t-2xl
							w-fit
							min-w-full
						"
					>
						<table class="min-w-full divide-y text-neutral-200">
							<thead class="bg-neutral-100 h-16">
								<tr>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											w-16
											whitespace-nowrap
										"
									>
										STT
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
											w-32
										"
									>
										Tên học sinh
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
											w-32
										"
									>
										TRỊ LIỆU VIÊN
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
										"
									>
										Mô hình
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
										"
									>
										Số lượng VIDEO
									</th>
									<th
										scope="col"
										class="
											px-6
											py-3
											text-left text-xs
											font-semibold
											text-neutral-600
											uppercase
											tracking-wider
											whitespace-nowrap
										"
									>
										Dung lượng video đã sử dụng
									</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="(person, personIdx) in students"
									:key="person.id"
									:class="
										personIdx % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									"
									class="
										text-neutral-700
										hover:bg-orange-50
										cursor-pointer
									"
									@click="
										gotoStudentInfo(person.id, personIdx)
									"
								>
									<td>
										<div class="px-6 py-4 text-neutral-700">
											{{ personIdx + 1 }}
										</div>
									</td>
									<td
										class="px-6 py-4 text-neutral-700"
										style="width: 250px"
									>
										<div class="flex items-center">
											<div
												class="relative mr-4"
												v-if="personIdx !== 0"
											>
												<img
													class="
														shadow-sm
														inline-block
														h-6
														w-6
														rounded-full
													"
													:src="
														person?.profile_photo
															?.w200
													"
													alt=""
													v-if="
														person?.profile_photo
															?.w200
													"
												/>
												<span
													v-else
													class="
														inline-flex
														items-center
														justify-center
														h-6
														w-6
														rounded-full
													"
													:style="{
														background:
															person
																?.profile_photo
																?.default
																?.color,
													}"
												>
													<span
														class="
															font-medium
															leading-none
															text-white text-xs
														"
														>{{
															person
																?.profile_photo
																?.default
																?.initial
														}}</span
													>
												</span>
												<div
													v-if="
														person.state !==
														'active'
													"
													style="
														background-color: rgba(
															241,
															162,
															103,
															0.5
														);
													"
													class="
														absolute
														transform
														-translate-x-1/2
														-translate-y-1/2
														top-1/2
														left-1/2
														h-6
														w-6
														rounded-full
														flex
														items-center
														justify-center
													"
												>
													<svg
														width="14"
														height="14"
														viewBox="0 0 40 40"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z"
															fill="#FAF5F1"
														/>
													</svg>
												</div>
											</div>
											<div
												class="
													text-orange-600
													font-semibold
													hover:underline
												"
												style="max-width: 150px"
											>
												{{ person.name }}
											</div>
										</div>
									</td>
									<td
										class="
											px-6
											py-4
											whitespace-nowrap
											text-neutral-700
										"
									>
										<div
											v-if="
												person &&
												person?.assigned_staffs &&
												person?.assigned_staffs.length >
													0
											"
										>
											<div
												@click="
													isAdmin &&
														$router.push(
															`/record/employee/${staff.id}`
														)
												"
												:class="{
													'cursor-pointer': isAdmin,
												}"
												v-for="staff in person?.assigned_staffs"
												:key="staff.id"
											>
												<div
													class="
														flex
														items-center
														mb-2
													"
												>
													<img
														class="
															shadow-sm
															inline-block
															h-6
															w-6
															rounded-full
														"
														:src="
															staff?.profile_photo
																?.w200
														"
														v-if="
															staff?.profile_photo
																?.w200
														"
														alt=""
													/>
													<span
														v-else
														class="
															inline-flex
															items-center
															justify-center
															h-6
															w-6
															rounded-full
														"
														:style="{
															background:
																staff
																	?.profile_photo
																	?.default
																	?.color,
														}"
													>
														<span
															class="
																font-medium
																leading-none
																text-white
																text-xs
															"
															>{{
																staff
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
													<div
														class="
															ml-4
															text-blue-600
															font-semibold
														"
													>
														{{ staff?.name }}
													</div>
												</div>
											</div>
										</div>
									</td>
									<td
										class="
											px-6
											py-4
											whitespace-nowrap
											text-neutral-700
										"
									>
										<div class="flex items-center">
											<svg
												v-if="
													person?.has_personal_class
												"
												width="36"
												height="36"
												viewBox="0 0 36 36"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													fill-rule="evenodd"
													clip-rule="evenodd"
													d="M11.7506 11.2911V10.4867C11.7506 10.3699 11.7276 10.2543 11.6829 10.1465C11.6733 10.1234 11.6628 10.1008 11.6514 10.0787C11.6372 10.051 11.6215 10.0242 11.6044 9.99829C11.5842 9.96762 11.5622 9.93817 11.5383 9.9102C11.523 9.89224 11.507 9.87485 11.4902 9.85811C11.4077 9.77556 11.3097 9.7101 11.2019 9.66545C11.094 9.62079 10.9784 9.5978 10.8617 9.5978H9.77724C9.77724 9.17401 9.9456 8.76762 10.2452 8.46799C10.5449 8.16836 10.9513 8 11.375 8H25.9573C26.1671 8 26.3748 8.04135 26.5687 8.12161C26.7625 8.20192 26.9386 8.31962 27.087 8.46799C27.2354 8.61635 27.3531 8.79249 27.4334 8.98633C27.5137 9.18017 27.555 9.38794 27.555 9.5978V26.4022C27.555 26.6121 27.5137 26.8198 27.4334 27.0137C27.3531 27.2075 27.2354 27.3836 27.087 27.532C26.9386 27.6804 26.7625 27.7981 26.5687 27.8784C26.3748 27.9586 26.1671 28 25.9573 28H11.375C10.9513 28 10.5449 27.8316 10.2452 27.532C9.9456 27.2324 9.77724 26.826 9.77724 26.4022H10.8617C10.9784 26.4022 11.094 26.3792 11.2019 26.3346C11.3097 26.2899 11.4077 26.2244 11.4902 26.1419C11.5728 26.0593 11.6383 25.9613 11.6829 25.8535C11.7276 25.7457 11.7506 25.6301 11.7506 25.5133V24.7089C11.7506 24.5922 11.7276 24.4766 11.6829 24.3687C11.6383 24.2609 11.5728 24.1629 11.4902 24.0803C11.4587 24.0488 11.4249 24.0197 11.3891 23.9934C11.3313 23.9508 11.2685 23.9152 11.2019 23.8877C11.094 23.843 10.9784 23.82 10.8617 23.82H9.77724V22.8466H10.8617C10.9784 22.8466 11.094 22.8237 11.2019 22.779C11.3097 22.7343 11.4077 22.6689 11.4902 22.5863C11.5728 22.5038 11.6383 22.4058 11.6829 22.2979C11.6893 22.2825 11.6953 22.267 11.7008 22.2513C11.7129 22.2166 11.7228 22.1812 11.7306 22.1454C11.7391 22.1058 11.745 22.0656 11.7481 22.0252C11.7497 22.0028 11.7506 21.9803 11.7506 21.9578V21.1533C11.7506 21.0366 11.7276 20.921 11.6829 20.8132C11.6739 20.7912 11.6639 20.7697 11.6532 20.7487C11.6401 20.7232 11.6259 20.6984 11.6105 20.6744C11.5831 20.6316 11.5521 20.5911 11.5178 20.5536C11.5088 20.5438 11.4997 20.5342 11.4902 20.5248C11.4556 20.4901 11.4182 20.4585 11.3785 20.4301C11.3237 20.3909 11.2644 20.358 11.2019 20.3321C11.094 20.2874 10.9784 20.2645 10.8617 20.2645H9.77724V19.2911H10.8617C10.9784 19.2911 11.094 19.2681 11.2019 19.2234C11.3097 19.1788 11.4077 19.1133 11.4902 19.0308C11.5728 18.9482 11.6383 18.8502 11.6829 18.7424C11.7276 18.6346 11.7506 18.519 11.7506 18.4022V17.5978C11.7506 17.481 11.7276 17.3654 11.6829 17.2576C11.6383 17.1498 11.5728 17.0518 11.4902 16.9692C11.4077 16.8867 11.3097 16.8212 11.2019 16.7766C11.094 16.7319 10.9784 16.7089 10.8617 16.7089H9.77724V15.7355H10.8617C10.9784 15.7355 11.094 15.7126 11.2019 15.6679C11.3097 15.6232 11.4077 15.5577 11.4902 15.4752C11.5728 15.3927 11.6383 15.2947 11.6829 15.1868C11.7118 15.1172 11.7316 15.0442 11.742 14.9699C11.7447 14.9508 11.7467 14.9318 11.7482 14.9126C11.7498 14.8907 11.7506 14.8687 11.7506 14.8467V14.0422C11.7506 13.9255 11.7276 13.8099 11.6829 13.7021C11.6383 13.5942 11.5728 13.4962 11.4902 13.4137C11.4077 13.3311 11.3097 13.2657 11.2019 13.221C11.1489 13.199 11.094 13.1823 11.038 13.171C10.9801 13.1593 10.921 13.1534 10.8617 13.1534H9.77724V12.18H10.8617C10.9784 12.18 11.094 12.157 11.2019 12.1123C11.3097 12.0677 11.4077 12.0022 11.4902 11.9197C11.5728 11.8371 11.6383 11.7391 11.6829 11.6313C11.7276 11.5234 11.7506 11.4078 11.7506 11.2911ZM10.8627 10.2648H8.66655C8.54382 10.2648 8.44434 10.3643 8.44434 10.487V11.2908C8.44434 11.4135 8.54382 11.513 8.66655 11.513H10.8627C10.9854 11.513 11.0849 11.4135 11.0849 11.2908V10.487C11.0849 10.3643 10.9854 10.2648 10.8627 10.2648ZM8.66655 17.3759H10.8627C10.9854 17.3759 11.0849 17.4754 11.0849 17.5981V18.4019C11.0849 18.5246 10.9854 18.6241 10.8627 18.6241H8.66655C8.54382 18.6241 8.44434 18.5246 8.44434 18.4019V17.5981C8.44434 17.4754 8.54382 17.3759 8.66655 17.3759ZM10.8627 13.8204H8.66655C8.61717 13.8204 8.57154 13.8365 8.53467 13.8637C8.47989 13.9042 8.44434 13.9692 8.44434 14.0426V14.8464C8.44434 14.9691 8.54382 15.0686 8.66655 15.0686H10.8627C10.9854 15.0686 11.0849 14.9691 11.0849 14.8464V14.0426C11.0849 13.9199 10.9854 13.8204 10.8627 13.8204ZM10.8627 20.9315H8.66655C8.54382 20.9315 8.44434 21.031 8.44434 21.1537V21.9575C8.44434 22.0802 8.54382 22.1797 8.66655 22.1797H10.8627C10.9854 22.1797 11.0849 22.0802 11.0849 21.9575V21.1537C11.0849 21.031 10.9854 20.9315 10.8627 20.9315ZM10.8627 24.487H8.66655C8.54382 24.487 8.44434 24.5865 8.44434 24.7092V25.513C8.44434 25.6358 8.54382 25.7352 8.66655 25.7352H10.8627C10.9854 25.7352 11.0849 25.6358 11.0849 25.513V24.7092C11.0849 24.5865 10.9854 24.487 10.8627 24.487ZM22.9997 15.9167C22.9997 17.9877 21.3208 19.6667 19.2497 19.6667C17.1786 19.6667 15.4997 17.9877 15.4997 15.9167C15.4997 13.8456 17.1786 12.1667 19.2497 12.1667C21.3208 12.1667 22.9997 13.8456 22.9997 15.9167ZM25.4997 23.1108C25.4997 23.1108 24.2497 20.9167 19.2497 20.9167C14.2497 20.9167 12.9997 23.1109 12.9997 23.1109V23.4167C12.9997 24.107 13.5593 24.6667 14.2497 24.6667H24.2497C24.9401 24.6667 25.4997 24.107 25.4997 23.4167V23.1108Z"
													fill="#F1A267"
												/>
											</svg>
											<svg
												v-if="
													person?.has_day_care_class
												"
												width="36"
												height="36"
												viewBox="0 0 36 36"
												fill="none"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													d="M13.9967 28C14.214 27.9999 14.4291 27.9559 14.629 27.8706C14.829 27.7854 15.0096 27.6607 15.1602 27.5039C15.3108 27.3472 15.4282 27.1617 15.5054 26.9585C15.5825 26.7553 15.6179 26.5386 15.6093 26.3214L15.3391 17.8825L16.5167 17.1728C16.8171 16.9908 17.0636 16.732 17.2308 16.423C17.398 16.1141 17.4799 15.7662 17.468 15.4152L17.2329 8.61745C17.2272 8.45347 17.1581 8.29811 17.04 8.18416C16.922 8.0702 16.7643 8.00656 16.6002 8.00666C16.4369 8.00828 16.2805 8.07298 16.1638 8.18723C16.0471 8.30147 15.9791 8.45641 15.974 8.61964L15.8092 12.8556C15.8078 12.9819 15.7611 13.1034 15.6777 13.1981C15.5942 13.2929 15.4795 13.3546 15.3544 13.3719C15.285 13.3795 15.2147 13.3727 15.148 13.3518C15.0812 13.331 15.0195 13.2966 14.9667 13.2508C14.9139 13.205 14.8712 13.1488 14.8411 13.0857C14.811 13.0226 14.7943 12.954 14.792 12.8842L14.6272 8.64381C14.6233 8.49838 14.5715 8.35831 14.4797 8.24544C14.3879 8.13258 14.2613 8.05326 14.1197 8.01984C14.0353 8.00563 13.9492 8.00563 13.8648 8.01984C13.7232 8.05326 13.5967 8.13258 13.5049 8.24544C13.4131 8.35831 13.3612 8.49838 13.3573 8.64381L13.1925 12.8842C13.1902 12.954 13.1735 13.0226 13.1434 13.0857C13.1134 13.1488 13.0706 13.205 13.0178 13.2508C12.965 13.2966 12.9033 13.331 12.8366 13.3518C12.7699 13.3727 12.6996 13.3795 12.6301 13.3719C12.505 13.3546 12.3903 13.2929 12.3069 13.1981C12.2234 13.1034 12.1767 12.9819 12.1753 12.8556L12.0039 8.61964C11.9987 8.45336 11.9283 8.2958 11.8078 8.18108C11.6873 8.06635 11.5265 8.00369 11.3602 8.00666C11.1961 8.00656 11.0384 8.0702 10.9203 8.18416C10.8023 8.29811 10.7331 8.45347 10.7274 8.61745L10.5011 15.4174C10.4893 15.7684 10.5712 16.1163 10.7384 16.4252C10.9056 16.7342 11.1521 16.993 11.4525 17.175L12.6521 17.8957L12.3818 26.3214C12.3732 26.5388 12.4087 26.7557 12.486 26.959C12.5633 27.1623 12.6808 27.3479 12.8317 27.5047C12.9825 27.6615 13.1634 27.7862 13.3636 27.8713C13.5638 27.9564 13.7791 28.0002 13.9967 28Z"
													fill="#F1A267"
												/>
												<path
													d="M25.8125 16.2457C26.1252 15.6708 26.287 15.026 26.2827 14.3716C26.2673 12.2207 25.8784 8.02206 22.7872 8.00009C19.6959 7.97811 19.307 12.2119 19.2916 14.3716C19.2866 15.0258 19.4477 15.6706 19.7596 16.2457C20.0901 16.8558 20.5779 17.3663 21.1723 17.7243L21.4623 17.9001L21.1943 26.3214C21.1863 26.5355 21.2216 26.7489 21.298 26.9489C21.3744 27.149 21.4904 27.3316 21.639 27.4858C21.7876 27.64 21.9658 27.7627 22.1629 27.8465C22.3599 27.9303 22.5719 27.9735 22.7861 27.9735C23.0002 27.9735 23.2122 27.9303 23.4093 27.8465C23.6063 27.7627 23.7845 27.64 23.9331 27.4858C24.0817 27.3316 24.1977 27.149 24.2741 26.9489C24.3505 26.7489 24.3858 26.5355 24.3778 26.3214L24.1032 17.8957L24.3932 17.7199C24.9894 17.364 25.4795 16.855 25.8125 16.2457Z"
													fill="#F1A267"
												/>
											</svg>
										</div>
									</td>
									<td
										class="
											px-6
											py-4
											whitespace-nowrap
											text-neutral-700
										"
									>
										<div>
											{{
												person?.goal_medium_video_count
											}}
										</div>
									</td>
									<td
										class="
											px-6
											py-4
											whitespace-nowrap
											text-neutral-700
										"
									>
										<div>
											{{
												person?.goal_medium_video_size_count
											}}
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import dayjs from 'dayjs';
import { $api } from '@/services';
import Loading from '@/components/common/Loading';

export default {
	name: 'Media',
	components: { Loading },
	data() {
		return {
			media: {
				allocated_per_student_in_mb: 0,
				allocated_size: '',
				first_month_start: '',
				total_student: 2,
				unused_size: '',
				used_size: '',
			},
			isLoading: true,
			date: {
				month: new Date().getMonth(),
				year: new Date().getFullYear(),
			},
			students: [],
		};
	},

	watch: {
		date: {
			deep: true,
			handler(value) {
				if (value) {
					this.getMediaDetailByMonth();
					this.getStudents();
				}
			},
		},
	},

	created() {
		if (!this.isEnableMedia) {
			this.$router.push('/report/lesson');
		} else {
			const month = this.$route?.query?.month;
			if (month) {
				this.date = {
					month: month - 1,
					year: new Date().getFullYear(),
				};
			}
			this.getStudents();
			this.getMediaDetail();
		}
	},

	computed: {
		isEnableMedia() {
			return this.$store.state.profile.current_org.enable_goal_media;
		},
		dateTitle() {
			return dayjs(new Date(this.date.year, this.date.month, 1)).format(
				'MM/YYYY'
			);
		},
		datePayload() {
			return dayjs(new Date(this.date.year, this.date.month, 1)).format(
				'YYYY-MM-DD'
			);
		},
		isAdmin() {
			return this.$store.getters.isAdmin;
		},
	},

	methods: {
		prevDay() {
			const da = dayjs(new Date(this.date.year, this.date.month, 1))
				.subtract(1, 'month')
				.toDate();
			this.date = {
				month: da.getMonth(),
				year: da.getFullYear(),
			};
		},

		nextDay() {
			const da = dayjs(new Date(this.date.year, this.date.month, 1))
				.add(1, 'month')
				.toDate();
			this.date = {
				month: da.getMonth(),
				year: da.getFullYear(),
			};
		},
		gotoStudentInfo(personId, index) {
			if (index == 0) return;
			this.$router.push(
				this.isAdmin
					? `/record/student/${personId}`
					: `/record/student/${personId}/info`
			);
		},

		async getMediaDetailByMonth() {
			try {
				const {
					data: { data },
				} = await $api.org.mediaByMonth({
					month_start: this.datePayload,
				});
				this.media = data;
			} catch (e) {
				console.log(e);
			} finally {
				this.isLoading = false;
			}
		},

		async getMediaDetail() {
			try {
				const {
					data: { data },
				} = await $api.org.mediaCurrent();
				this.media = data;
			} catch (e) {
				console.log(e);
			} finally {
				this.isLoading = false;
			}
		},

		async getStudents() {
			try {
				const res = await $api.student.getStudentsInMedia(
					!this.isAdmin ? 'staff' : 'org_admin',
					{
						month_start: this.datePayload,
					}
				);
				this.students = res.data.data;
				let parent_uploaded_count = res.data.parent_uploaded_count;
				this.students.unshift({
					name: 'Video từ phụ huynh',
					goal_medium_video_count: parent_uploaded_count?.count,
					goal_medium_video_size_count: parent_uploaded_count?.size,
				});
			} catch (e) {
				console.log(e);
			} finally {
				this.isLoading = false;
			}
		},
	},
};
</script>
